var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-error"},[_c('img',{staticClass:"img-error",attrs:{"src":require("../../../../public/img/icons/alert_error.png"),"alt":""}}),_c('p',{staticClass:"text-error"},[_vm._v(_vm._s(_vm.textError))])])}
var staticRenderFns = []

export { render, staticRenderFns }